
import {Component, Prop, Vue} from 'vue-property-decorator';
import {IQueue} from '@pazion/pazion-core/src/models/queuemodels/queue';
import QueueStatusesArrow from './QueueStatusesArrow.vue';
import * as dayjs from 'dayjs';

@Component({
  components: {
    QueueStatusesArrow
  }
})
export default class StatusesArrowWrapper extends Vue {

  @Prop() itemData!: IQueue | null

  get getChildrens() {
    if (this.itemData && this.itemData.length > 0) {
      const sortedChildren = this.itemData.sort((a, b) => {
        const aDate = a.modifiedAt ? a.modifiedAt : a.createdAt;
        const bDate = b.modifiedAt ? b.modifiedAt : b.createdAt;
        return dayjs(aDate).diff(dayjs(bDate))
      })
      return sortedChildren
    }
    return this.itemData
  }

}//
